import { SET_TRANSACTION_QUERY } from '.';

export const setTransactionQueryAction = (transactionQuery) => ({
  type: SET_TRANSACTION_QUERY,
  payload: transactionQuery,
});
